import { useDialog } from 'primevue/usedialog'
import type { DynamicDialogOptions } from 'primevue/dynamicdialogoptions'

export const useDynamicDialog = () => {
  const dialog = useDialog()

  /*
   * Open a dialog with the given content
   * On mobile, the dialog will be maximized
   * Can be customized fully with the options parameter
   */
  function open(content: any, options?: DynamicDialogOptions) {
    const showHeader = options?.props?.header !== undefined ? options.props.showHeader : false

    const defaultOptions: DynamicDialogOptions = {
      props: {
        showHeader: showHeader,
        style: {
          width: 'auto',
          height: 'auto',
        },
        draggable: false,
        contentClass: 'h-full',
        dismissableMask: true,
        closable: true,
        modal: true,
      },
    }
    const mergedOptions = mergeDeep(defaultOptions, options || {})

    dialog.open(content, mergedOptions)
  }

  /*
   * Only deep-merge plain objects. Anything else (arrays, Date, Map, Set, class
   * instances) is assigned by reference — recursing into a Date object iterates
   * zero enumerable keys, which used to silently replace it with `{}`.
   */
  function isPlainObject(value: unknown): value is Record<string, unknown> {
    if (value === null || typeof value !== 'object') return false
    const proto = Object.getPrototypeOf(value)

    return proto === null || proto === Object.prototype
  }

  function mergeDeep(target: DynamicDialogOptions, source: DynamicDialogOptions) {
    for (const key in source) {
      if (isPlainObject(source[key])) {
        if (!isPlainObject(target[key])) {
          target[key] = {}
        }
        mergeDeep(target[key], source[key])
      } else {
        target[key] = source[key]
      }
    }

    return target
  }

  return {
    open,
  }
}
